<template>
    <div>
        <b-alert :show="isToShowEmptyListAlert" class="m-0">
            <span>{{ $t('isEmptyAlert') }}</span>
        </b-alert>
        <b-card class="mb-2" v-for="keyResult in keyResults" :key="keyResult.id">
            <KeyResultDetails
                :key-result="keyResult"
                :bold-title="boldTitle"
                @onDeletedKeyResult="$emit('onDeletedKeyResult')"
            />
        </b-card>
    </div>
</template>

<script>
import KeyResultDetails from '../key-result/details'

export default {
    name: 'KRs',
    components: {
        KeyResultDetails,
    },
    props: {
        keyResults: {
            type: Array,
            required: true,
        },
        boldTitle: {
            type: Boolean,
            required: false,
        },
    },
    computed: {
        isToShowEmptyListAlert() {
            return this.keyResults.length === 0
        },
    },
    i18n: {
        messages: {
            'en-US': {
                isEmptyAlert: "You don't have any key result yet.",
            },
            'es-ES': {
                isEmptyAlert: 'Todavía no tienes ningún resultado clave.',
            },
            'pt-BR': {
                isEmptyAlert: 'Você ainda não possui resultados chave.',
            },
        },
    },
}
</script>
